import Vue from 'vue'
import db from '../common/localstorage'

export default Vue.directive('auth', {
  inserted: function (el, binding, vnode) {
    const currrent = db.get('currentMenu');
    currrent.children = currrent.children || [];
    const currrentChild = db.get('currentChild');
    currrentChild.children = currrentChild.children || [];
    // 获取传入的权限码value（string or array）和修饰符modifiers
    let {value, modifiers} = binding;
    if (modifiers.some) {
      let isHave = value.some(v => {
        return currrent.children.find(item => item.id == v) || currrentChild.children.find(item => v)
      });
      if (!isHave) {
        el.parentNode.removeChild(el);
      }
    } else {
      let isHave = currrent.children.find(item => item.id == binding.value) || currrentChild.children.find(item => item.id == binding.value);
      if (!isHave && currrent.id != binding.value) {
        el.parentNode.removeChild(el);
      }
    }

  }
})